var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppRow',{attrs:{"permission":"UNDEFINED"}},[_c('v-col',[_c('v-alert',{attrs:{"outlined":"","type":"error"}},[_vm._v(" Этот раздел отключен! ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }